/**
 * Formats a number of cents into a currency string using the provided
 * precision, thousands separator, and decimal separator.
 *
 * @param number - The number of cents to format.
 * @param precision - The number of decimal places to include.
 * @param thousands - The character to use as the thousands separator.
 * @param decimal - The character to use as the decimal separator.
 * @returns The formatted currency string.
 */
export const formatWithDelimiters = (
  number: number,
  precision = 2,
  thousands = ',',
  decimal = '.',
): string => {
  if (isNaN(number)) {
    return '0'
  }

  const percentageString = (number / 100.0).toFixed(precision)
  const parts = percentageString.split('.')
  const dollars = parts[0].replaceAll(
    /(\d)(?=(\d{3})+(?!\d))/g,
    `$1${thousands}`,
  )
  const cents = parts[1] ? decimal + parts[1] : ''

  return dollars + cents
}
